import React from 'react';
import {MenuItem, SelectField} from 'material-ui';

export default ({label, selectedItem, items, changeMethod}) =>
  <SelectField
    floatingLabelText={label}
    fullWidth
    value={selectedItem}
    onChange={(_, __, value) => changeMethod(value)}>
    {items.map((item, idx) => <MenuItem key={idx} value={item._id} primaryText={item.name} />)}
  </SelectField>;



// WEBPACK FOOTER //
// ./src/components/Select.js